import React from "react";
import {useTranslation} from "react-i18next";
import {PermissionPolicyList} from "../../permissionPolicyList/PermissionPolicyList";

export const UserPermissionPoliciesTab = ({
    permissionPolicies = [],
    loading = false,
    csrSearchText = ""
}) => {
    const {t} = useTranslation([]);

    return (
        <div>
            <PermissionPolicyList
                permissionPolicies={permissionPolicies}
                loading={loading}
                csrSearchText={csrSearchText}
            />
        </div>
    );
};
